import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { RequestHistoryService } from '../../../services/requestHistory.service';

import { OAuthService } from '../../../services/oauth.service';

import { DialogComponent } from '../dialog/dialog.component';

import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog-history-table.component.html',
  styleUrls: ['./dialog-history-table.component.scss','../../../styles/csc-theme.scss']
})
export class DialogHistoryComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DialogHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private requestService: RequestHistoryService,
    private dialog: MatDialog,
    private oAuthService: OAuthService) {

  }

  indexLoading = null;

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    //check why method is empty
  }

  isLoading(i: number) {
    return i === this.indexLoading;
  }

  requestHistory(url: string, name: string, i: number) {
    this.indexLoading = i;
    this.requestService.downloadPDF(url, RequestHistoryService.FORMAT_PDF).subscribe(
      (res) => {
        this.indexLoading = null;
        this.downloadFile(res, name);
      }, (err) => {
        this.indexLoading = null;
        const errMsg = err.message ? err.message : 'Server has encountered a problem. <br>Sorry for inconvenience, we are working on it';
        const data = { message: `${errMsg}. Please try again.` };
        this.dialog.open(DialogComponent, { data });
        throw err;
      });
  }

  downloadFile(data: any, name: string) {
    name.replace('/', '-');
    const blob = new Blob([data], { type: 'application/pdf' });
    FileSaver.saveAs(blob, `report-${name}`);
  }

}
